export const scrollIntoViewById = (elementId: string): void => {
  const { document } = window

  const elementScrollTo = document.getElementById(elementId)

  if (!elementScrollTo) return

  elementScrollTo.scrollIntoView({ behavior: 'smooth', block: 'start' })
}
